<template>
	<div class="container">
		<div class="content">
			<loading-spin :height='400'></loading-spin>
		</div>
	</div>
</template>

<script>

import LoadingSpin from './Parts/LoadingSpin'

export default {
	components: {
		'loading-spin': LoadingSpin
	}
}
</script>

<style scoped>
	.content {
		min-heigth: 100vh;
	}
</style>
